<template>
    <div>
        <h1 style="font-size: 24px; color: black;">商店管理</h1>
        <el-card class="form-container" shadow="never">
            <el-form :inline="true" :model="queryData" size="small" label-width="140px">
                <el-form-item label="商品标签：">
                    <el-cascader
                            v-model="queryData.classifyId"
                            :options="totalClassifyList"
                            :props="{emitPath: false,value:'id',label:'name',multiple: false,checkStrictly: true}"
                            ></el-cascader>
                </el-form-item>
                <el-form-item label=" " class="sub-sub11" >
                    <el-button type="primary" @click="queryList">查询</el-button>
<!--                    <el-button class="sub-sub" type="primary" @click="jumpOrderManage">订单查询</el-button>-->
<!--                    <el-button class="sub-sub" type="primary" @click="jumpShelvesManage">标签管理</el-button>
                    <el-button class="sub-sub" type="primary" @click="jumpShopDailyManage">每日优惠</el-button>-->
                    <el-button class="sub-sub" type="primary" @click="showDetails('创建商品')">创建商品</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <h1>
            <el-table border :data="dataList">
                <el-table-column label="商品ID" prop="id"  align="center"></el-table-column>
                <el-table-column label="商品标签"   align="center">
                    <template slot-scope="scope">
                        {{scope.row.id | iosFilter(cupBoardShopStockObj)}}
                    </template>
                </el-table-column>
                <el-table-column label="商品名称" prop="name" show-overflow-tooltip align="center"></el-table-column>
                <el-table-column label="物品类型" prop="cid" :formatter="transform" width="140px" align="center"></el-table-column>
                <el-table-column label="商品图片" align="center" width="100px">
                    <template slot-scope="scope">
                        <template>
                            <img :src="VUE_APP_CDN_URL+scope.row.image" width="60px" height="60px"/>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="商品视频" align="center">
                    <template slot-scope="scope" v-if="scope.row.video">
                        <el-button type="text" @click="showVideo(scope.row)">查看视频</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="售卖时间" align="center">
                    <el-table-column label="开始时间"  width="160px" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.startDt | dateTimeFormat}}
                        </template>
                    </el-table-column>
                    <el-table-column label="结束时间"  width="160px" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.endDt | dateTimeFormat}}
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="永久有效" align="center" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.isForever === true">是</span>
                        <span v-if="scope.row.isForever === false">否</span>
                    </template>
                </el-table-column>
                <el-table-column label="金币(原价)" align="center" prop="originalPrice"></el-table-column>
                <el-table-column label="金币(现价)" align="center" prop="currentPrice"></el-table-column>
                <el-table-column label="库存" align="center" prop="stockNumber"></el-table-column>
                <el-table-column label="已售卖" align="center" >
                    <template slot-scope="scope">
                        {{scope.row.id | iosFilter(iosShopStockObjCupBoard)}}
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="150px">
                    <template slot-scope="scope">
                        <el-button plain size="mini" type="primary" @click="showDetails('编辑商品',scope.row)">编辑</el-button>
                        <el-button plain size="mini" type="danger" @click="removeItem(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-row>
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="page.page"
                        :page-sizes="[1,10,20,30,50]"
                        :page-size="page.size"
                        layout="total, sizes, prev, pager, next"
                        :total="page.totalElements">
                </el-pagination>
            </el-row>
            <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="800px"
                       :close-on-click-modal="false">
                <el-form :model="itemForm" label-width="150px">
<!--                    <el-form-item label="物品ID :" >
                        <el-select  v-model="itemForm.goodId" placeholder="请选择" @change="findGood">
                            <el-option
                                    v-for="item in goods"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>-->
                  <el-form-item label="物品ID :">
                    <el-select v-model="itemForm.ids" placeholder="请选择" @change="findGood" multiple>
                      <el-option
                          v-for="item in goods"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                    <el-form-item label="商品标签：" v-if=" dialogTitle!== '编辑商品' ">
                        <el-cascader  
                                v-model="queryData.classifyId"
                                :options="totalClassifyList"
                                :props="{emitPath: false,value:'id',label:'name',multiple: false,checkStrictly: true}"
                                clearable></el-cascader>
                    </el-form-item>
                    <el-form-item label="商品名称 :">
                        <el-input style="width: 300px" type="text" v-model="itemForm.name"  ></el-input>
                    </el-form-item>
                    <el-form-item label="物品类型:">
                        <el-cascader
                                v-model="itemForm.cid"
                                :options="categoryList"
                                :props="{emitPath: false,value:'cid',label:'name'}"
                                disabled></el-cascader>
                    </el-form-item>
                    <el-form-item label="物品等级:">
                        <el-select v-model="itemForm.level" disabled>
                            <el-option
                                    v-for="item in goodLevelList"
                                    :label="item.name"
                                    :value="item.id"
                                    :key="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="物品描述 :" >
                        <el-input style="width: 300px" type="textarea" :rows="3" v-model="itemForm.description" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="上架时间 :" >
                        <el-date-picker
                                v-model="itemForm.startDt"
                                type="datetime"
                                placeholder="开始时间">
                        </el-date-picker>
                        <span>至</span>
                        <el-date-picker
                                v-model="itemForm.endDt"
                                type="datetime"
                                placeholder="结束时间">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="角标类型:">
                        <el-select v-model="itemForm.cornerType" >
                            <el-option
                                    v-for="item in corners"
                                    :label="item.name"
                                    :value="item.id"
                                    :key="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="货币类型:">
                        <el-select v-model="itemForm.currencyType" >
                            <el-option
                                    v-for="item in currencies"
                                    :label="item.name"
                                    :value="item.id"
                                    :key="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="货币原价 :" >
                    <el-input-number v-model="itemForm.originalPrice"  :min="1" ></el-input-number>
                    </el-form-item>
                    <el-form-item label="货币折价 :" >
                        <el-input-number v-model="itemForm.currentPrice"  :min="1" ></el-input-number>
                    </el-form-item>
                    <el-form-item label="视频获取 :" >
                        <el-radio-group v-model="itemForm.adFlag">
                            <el-radio :label="true">是</el-radio>
                            <el-radio :label="false">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="永久有效 :" >
                        <el-radio-group v-model="itemForm.isForever">
                            <el-radio :label="true">是</el-radio>
                            <el-radio :label="false">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="图片 :" >
                        <el-upload :headers="headers"
                                   class="avatar-uploader"
                                   :action="uploadURL"
                                   :show-file-list="false"
                                   :on-success="handleCISuccess"
                                   :before-upload="beforeAvatarUpload">
                            <img v-if="itemForm.image" :src="VUE_APP_CDN_URL+itemForm.image" class="avatar">
                            <i v-else class="el-icon-picture avatar-uploader-icon"></i>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="视频 :" >
                        <el-upload :headers="headers"
                                   class="avatar-uploader"
                                   :action="uploadURL"
                                   :show-file-list="false"
                                   :on-success="handleVideoSuccess"
                                   :before-upload="beforeVideoUpload">
                            <video v-if="itemForm.video" :src="VUE_APP_CDN_URL+itemForm.video"
                                   class="avatar1"
                                   controls="controls"/>
                            <i v-else class="el-icon-picture avatar-uploader-icon"></i>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="商品库存 :" >
                        <el-input-number v-model="itemForm.stockNumber"  :min="0" ></el-input-number>
                        <el-tag type="success" class="sub-sub"> 默认999999999代表无穷</el-tag>
                    </el-form-item>
                    <el-form-item label="限购数量 :" >
                        <el-input-number v-model="itemForm.personLimitNumber"  :min="0" ></el-input-number>
                        <el-tag type="success" class="sub-sub"> 默认999999999代表无穷</el-tag>
                    </el-form-item>
                    <div style="text-align: center;">
                        <el-button type="primary" @click="confirm">确 定</el-button>
                        <el-button type="info" @click="cancel">取 消</el-button>
                    </div>
                </el-form>
            </el-dialog>
            <el-dialog title="视频详情"
                       center
                       :visible.sync="videoDialogVisible"
                       @close="videorDialogVisible=false"
                       width="320px">
                <div>
                    <video :src="VUE_APP_CDN_URL+this.videoTmpePath" style="width: 270px; height: 480px" class="avatar1"
                           controls="controls"/>
                </div>
            </el-dialog>
        </h1>
    </div>

</template>

<script>
import {
  CupBoardShopSelections,
  CupBoardSearchShop,
  CupBoardDeleteShopItem,
  CupBoardSaveShopItem,
  findGoodById,
  goodsSelections, cupBoardShopItemClassifyList,
} from "@/http/iosApi";
    import settingMix from '@/utils/mix/common-setting'
    export default {
        name: "CupBoardShopManage",
        mixins: [settingMix],
        data(){
            return{
                categoryList:[],
                totalClassifyList:[],
                categoryAll:[],
                needCategoryInfo:true,
                needCategoryAll:true,
              cupBoardShopStockObj:{},
              iosShopStockObjCupBoard:{},
                VUE_APP_IOS_URL: '',
                VUE_APP_CDN_URL: '',
                videoTmpePath: '',
                videoDialogVisible: false,
                dialogVisible: false,
                dialogTitle: '',
                headers: {},
                labelWidth: '200px',
                uploadURL: process.env.VUE_APP_IOS_URL + "block/upload",
                queryData: {
                    classifyId : 1,
                    prop: "rank",
                    order: "desc"
                },
                page: {
                    size: 10,
                    page: 1,
                    totalElements: null
                },
                itemForm:{
                    "id": 0,
                    "adFlag": true,
                    "isForever":true,
                    "cid": 1,
                    "cornerType": 0,
                    "currencyType": 0,
                    "currentPrice": 0,
                    "description": '',
                    "goodId": 1,
                    "image": '',
                    "name": '',
                    "originalPrice": 0,
                    "personLimitNumber": 999999999,
                    "startDt": '',
                    "endDt": '',
                    "stockNumber": 999999999,
                    "video": '',
                    "level" :0,
                    "deleted": 0,
                  "ids": []
                },
                dataList:[],
                corners:[],
                currencies:[],
                goodLevelList:[],
                needGoodLevel:true,
                tempId:0,
                goods:[],
            }
        },
        methods:{
            getSelections(){
              CupBoardShopSelections().then(resp => {
                    this.totalClassifyList = resp.data.info.totalClassifyList;
                    this.corners = resp.data.info.corners;
                    this.currencies = resp.data.info.currencies;
                })
            },
            transform:function(row){
                const arr = this.categoryAll;
                var parent;
                var child = arr.filter(it => it.cid === row.cid);
                if (child.length>0){
                    if (child[0].parentCid !== 0){
                        parent = arr.filter(item => item.cid === child[0].parentCid);
                    }
                    return parent[0].name+'/'+child[0].name;
                }
            },
            transformClassify:function(row){
                const arr = this.totalClassifyList;
                var parent;
                var child = arr.filter(it => it.cid === row.cid);
                if (child.length>0) {
                    if (child[0].parentCid !== 0) {
                        parent = arr.filter(item => item.cid === child[0].parentCid);
                    }
                    return parent[0].name + '/' + child[0].name;
                }
            },
          queryList() {
            this.queryData.size = this.page.size;
            this.queryData.page = this.page.page;
            CupBoardSearchShop(this.queryData).then(resp => {
              if (resp.data.status === 0) {
                this.dataList = resp.data.info.content;
                if (this.dataList.length > 0) {
                  for (let x in this.dataList) {
                    if (this.dataList[x].ids != null) {
                      let a = this.dataList[x].ids.split(',')
                      for (let y in a) {
                        a[y] = a[y] / 1
                      }
                      this.dataList[x].ids = a
                    }
                  }
                }
                this.page.totalElements = resp.data.info.totalElements;
              }
            })
          },
        /*    queryList() {
                this.queryData.size = this.page.size;
                this.queryData.page = this.page.page;
                searchShop(this.queryData).then(resp => {
                    if (resp.data.status === 0) {
                        this.dataList = resp.data.info.content;
                        this.page.totalElements = resp.data.info.totalElements;
                    }
                })
            },*/
            handleCurrentChange(page) {
                this.page.page = page;
                this.queryList();
            },
            jumpShelvesManage(){
                this.$router.push({ path: '/shelvesManage'});
            },
            jumpShopDailyManage(){
                this.$router.push({ path: '/shopDailyManage'});
            },
            jumpOrderManage(){
                this.$router.push({ path: '/orderData'});
            },
            handleSizeChange(size) {
                this.page.size = size;
                this.queryList();
            },
            handleCISuccess(response) {
                this.itemForm.image = response.info;
            },
            handleVideoSuccess(response) {
                this.itemForm.video = response.info;
            },
            beforeAvatarUpload(file) {
                const isIcon = file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/gif';
                const isLt2M = file.size / 1024 / 1024 < 1;
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过1MB!');
                }
                if (!isIcon) {
                    this.$message.error('上传图片只能是png,jgp,jpeg格式!');
                }
                return isIcon && isLt2M;
            },
            beforeVideoUpload(data) {
                const type = data.name.substring(data.name.lastIndexOf('.')) === '.mp4' || data.name.substring(data.name.lastIndexOf('.')) === '.mov';
                const size = data.size < 1024 * 1024 * 20;
                if (!type) {
                    this.$message.error('上传视频只能是mp4/mov格式!');
                }
                if (!size) {
                    this.$message.error('上传视频大小不能超过20m!');
                }
                return type && size;
            },
            showDetails(title, row) {
                this.goodsSelections();
                this.itemForm={
                    "id": 0,
                        "adFlag": true,
                        "cid": 1,
                        "isForever":true,
                        "cornerType": 0,
                        "currencyType": 0,
                        "currentPrice": 0,
                        "description": '',
                        "endDt": '',
                        "startDt": '',
                        "goodId": 1,
                        "image": '',
                        "name": '',
                        "originalPrice": 0,
                        "personLimitNumber": 999999999,
                        "stockNumber": 999999999,
                        "video": '',
                        "level" :0,
                  "ids": [],
                        "deleted": 0
                },
                this.dialogTitle = title;

                if (title==="创建商品" ){
                    this.tempId = this.queryData.classifyId;
                if (this.queryData.classifyId === 1) {
                    //默认别创建全部类型的商品
                    this.queryData.classifyId = 2001000
                  }
                }
                this.dialogVisible = true;
                if (row) {
                    this.itemForm={
                        "id": row.id,
                        "adFlag": row.adFlag,
                        "isForever":row.isForever,
                        "cid": row.cid,
                        "cornerType": row.cornerType,
                        "currencyType": row.currencyType,
                        "currentPrice": row.currentPrice,
                        "description": row.description,
                        "endDt": row.endDt,
                        "goodId": row.goodId,
                        "image": row.image,
                        "name": row.name,
                        "originalPrice": row.originalPrice,
                        "personLimitNumber": row.personLimitNumber,
                        "startDt": row.startDt,
                        "stockNumber": row.stockNumber,
                        "video": row.video,
                        "deleted": row.deleted,
                      "ids": row.ids,
                        "level": row.level
                    }
                }
            },
          findGood() {
            findGoodById(this.itemForm.ids[0]).then(resp => {
              if (resp.data.status === 0) {
                this.itemForm.name = resp.data.info.name;
                this.itemForm.cid = resp.data.info.cid;
                //同步设置物品类型与商品标签一致 物品类型是固定的 标签类型集合可能会多余物品类型
                this.itemForm.description = resp.data.info.description;
                this.itemForm.video = resp.data.info.videoPath;
                this.itemForm.image = resp.data.info.imageUrl;
              }
            })
          },
        /*    findGood(){
                findGoodById(this.itemForm.goodId).then(resp => {
                    if (resp.data.status === 0) {
                        this.itemForm.name = resp.data.info.name;
                        this.itemForm.cid = resp.data.info.cid;
                        //同步设置物品类型与商品标签一致 物品类型是固定的 标签类型集合可能会多余物品类型
                        this.queryData.classifyId = resp.data.info.cid;
                        this.itemForm.description = resp.data.info.description;
                        this.itemForm.video =  resp.data.info.videoPath;
                        this.itemForm.image =  resp.data.info.imageUrl;
                    }
                })
            },*/

            showVideo: function (data) {
                this.videoDialogVisible = true;
                this.videoTmpePath = data.video;

            },
            cancel() {
                if (this.dialogTitle === '创建商品'){
                    this.queryData.classifyId = this.tempId;
                }
                this.dialogVisible = false;
            },
            goodsSelections(){
                goodsSelections().then(resp =>{
                    this.goods = resp.data.info;
                })
            },
            confirm() {
                let _message = '';
                if (this.itemForm.name === '') {
                    _message = '请选择商品'
                }else if (!this.itemForm.isForever & (this.itemForm.startDt === '' || this.itemForm.endDt === '')){
                    _message = '请选择时间'
                }
                if (_message) {
                    this.$message({
                        message: _message,
                        type: 'error'
                    });
                    return;
                }
              this.itemForm.ids = this.itemForm.ids.toString()
                console.log(this.itemForm)
                CupBoardSaveShopItem(this.queryData.classifyId,this.itemForm).then(resp => {
                    if (resp.data.status === 0) {
                        this.queryList();
                        this.dialogVisible = false;
                    }
                })
            },
            removeItem(id) {
                this.$confirm('此操作将删除该商品, 是否继续?', '提示', {
                    cancelButtonClass: 'btn-custom-cancel',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    CupBoardDeleteShopItem(id).then(resp => {
                        if (resp.data.status === 0) {
                            this.queryList();
                        }
                    });
                }).catch(() => {
                })
            },
        },
        created() {
            this.headers = {Authorization: this.$store.state.user.token}
            this.getSelections();
            this.queryList();
        },
        mounted() {
            this.VUE_APP_IOS_URL = process.env.VUE_APP_IOS_URL;
            this.VUE_APP_CDN_URL = process.env.VUE_APP_CDN_URL;
        }
    }
</script>

<style scoped>

</style>
